module.exports = __webpack_public_path__ + "img/img1.469c0bed.png";